import { Box, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import ProfilePanel from "./ProfilePanel";
import TabPanel from "@components/tab/TabPanel";
import {tabProps} from "@pages/asset/styles";

/**
 * 마이페이지.
 *
 * **«비밀번호 변경» 탭을 뺐다.** 비밀번호로 들어오는 길이 없어졌으므로
 * (`POST /auth/login` 제거) 바꿔 봐야 **아무 데도 쓰이지 않는다.** 남겨 두면
 * «바꿨으니 이제 그 비밀번호로 들어가면 되겠지» 라고 믿게 만든다 — 실제로는
 * 메일로 오는 로그인 링크가 유일한 입구다.
 *
 * 탭이 하나만 남았지만 구조는 그대로 둔다. 프로필 말고 다른 것이 붙을 자리다.
 */
function MypageTabs() {
  const handleChange = (event: React.SyntheticEvent<Element, Event>, newValue: any) => {
    setValue(newValue);
  };

  const [value, setValue] = useState(0);

  return (
    <>
      <Box sx={{ marginTop: 5, borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="마이페이지 탭"
        >
          <Tab label="프로필 관리" {...tabProps(0)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <ProfilePanel />
      </TabPanel>
    </>
  );
}

export default MypageTabs;
